'use client'

import { Cell, Text, Icon } from '@vinted/web-ui'
import { CancelCircleFilled24 } from '@vinted/monochrome-icons'

type Props = {
  title: string
  body: string
}

const ErrorBanner = ({ title, body }: Props) => {
  return (
    <Cell
      theme="warning"
      prefix={
        <Icon
          name={CancelCircleFilled24}
          color="greyscale-level-6"
          aria={{ 'aria-hidden': 'true' }}
        />
      }
      title={<Text as="h2" text={title} theme="inverse" type="title" />}
      body={<Text as="span" text={body} theme="inverse" type="body" />}
    />
  )
}

export default ErrorBanner
